import React, { useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useReactToPrint } from 'react-to-print';
import { Button, Icon } from 'semantic-ui-react';
import { setPage } from '../../redux/appSlice';
import SubsidyContractCover from '../Contract/SubsidyContractCover';
import { setLetter } from "../../redux/projectSlice";
import axios from 'axios';

const useTitle = (title) => {
    useEffect(() => {
        const prevTitle = document.title;
        document.title = title;
        return () => {
            document.title = prevTitle;
        }
    })
}

const SubsidyContractService = () => {

    const projectState = useSelector(state => state.project);
    const API_MDB = process.env.REACT_APP_BASE_API_URL_MDB;
    const dispatch = useDispatch();
    const options = {
        headers: { 'Content-Type': 'application/json' },
        withCredentials: true
    }
    const componentRef = useRef();

    const handlePrint = useReactToPrint({
        content: () => componentRef.current
    });

    const updateLetterDataAndPrint = async () => {
        const resLetter = await axios.patch(API_MDB + '/letters/' + projectState.letter._id, projectState.letter, options);
        if (resLetter.status === 204) {
            handlePrint();
        }
    }

    const getLetterData = async () => {
        if (!projectState.letter.projectNumber) {
            const resLetter = await axios.get(API_MDB + '/letters/' + projectState.project.customIdentifier, options);
            if (resLetter.status === 200) {
                let letter = resLetter.data
                    dispatch(setLetter(letter));
                } else {
                    console.error('Error fetching letter data');
                }
            } 
        }
        
    useTitle(projectState.project.customIdentifier + ' ' + projectState.project.acronym+'_Subsidy Contract Cover Letter');
    
    getLetterData();
    return ( 
        <div>
            <div className='menu'>
                <Button.Group>
                    <Button icon onClick={() => dispatch(setPage('Projects'))} color='blue' labelPosition='left'>
                        <Icon name='arrow left' />
                        Back
                    </Button>
                    <Button.Or />
                    <Button icon onClick={updateLetterDataAndPrint} color='blue' labelPosition='right'>
                        <Icon name='print' />
                        Print
                    </Button>
                </Button.Group>
            </div>
            <SubsidyContractCover ref={componentRef} projectState={projectState} />
        </div>
    );
}

export default SubsidyContractService;